<template>
    <div
        v-if="isFaqLoadedWithError"
        class="inline-warning-block"
    >
        {{ $t('errors.faqOpening') }}
    </div>
    <div class="arrow_container">
        <div class="arrow_title_container">
            <div class="arrow_title">
                {{ $t('meya.contact_us_1') }}
            </div>
            <div class="arrow_title">
                {{ $t('meya.contact_us_2') }}
            </div>
            <div class="arrow_title">
                {{ $t('meya.contact_us_3') }}
            </div>
            <div class="arrow_title">
                {{ $t('meya.contact_us_4') }}
                <router-link
                    v-slot="{ navigate }"
                    :to="{ name: 'Feedback' }"
                    custom
                >
                    <a
                        class="arrow_link"
                        role="link"
                        @click="navigate"
                        @keypress.enter="navigate"
                    >
                        {{ $t('meya.contact_us_4_link') }}
                    </a>
                </router-link>
            </div>
            <div class="arrow_title">
                {{ $t('meya.contact_us_5') }}
            </div>
        </div>
        <div class="arrow" />
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import api from '@/api';
import testNetwork from '@/modules/networkStatus';

export default {
    name: 'MeyaChat',
    computed: {
        ...mapState({
            queryParams: state => state.queryParams,
            isNetworkTestLoaded: state => state.feedback.networkTest.isLoaded,
            isFaqLoadedWithError: state => state.FAQ.isFaqLoadedWithError,
        }),
    },
    created() {
        if (!this.isNetworkTestLoaded) this.requestNetworkTest();
    },
    mounted() {
        window.addEventListener('beforeunload', this.beforeUnloadEvent);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.beforeUnloadEvent);
    },
    methods: {
        ...mapMutations({
            setNetworkTestData: 'feedback/setNetworkTestData',
            setNetworkTestLoaded: 'feedback/setNetworkTestLoaded',
        }),
        requestNetworkTest() {
            api.getGameServers(this.queryParams)
                .then(response => ({
                    servers: response.data.data,
                    pushdStatus: this.queryParams?.pushd ?? '-'
                }))
                .then(testNetwork)
                .then(result => {
                    this.setNetworkTestData(result);
                    this.setNetworkTestLoaded();
                })
                .catch(err => {
                    console.error(err);
                });
        },
        beforeUnloadEvent(event) {
            event.preventDefault()
            event.returnValue = '';
        },
        goToSupportForm() {

        },
    },
}
</script>
